import React from 'react';

import { Wrapper, Button } from './styled/TrainerTranscriptCopyButtonStyled';

interface LocalizationLike {
    getText: (key: string) => string;
}

function CopyButton({ localization, onCopy, enabled }: { localization: LocalizationLike; onCopy: () => void; enabled: boolean }) {
    return (
        <Wrapper data-testid="copy-button">
            <Button $enabled={enabled} onClick={onCopy}>
                {enabled
                    ? localization.getText('trainer.transcript.copy_button.to_copy')
                    : localization.getText('trainer.transcript.copy_button.copied')}
            </Button>
        </Wrapper>
    );
}

export default CopyButton;
